import { render, staticRenderFns } from "./Dehydration.vue?vue&type=template&id=6e2ca004"
import script from "./Dehydration.vue?vue&type=script&lang=js"
export * from "./Dehydration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports